<template>
  <div class="comp-container">
    <div class="title">
      <img src="@saas/pages/assets/images/live-data/ranking.png" alt="" />
      <p>学员排名</p>
      <div class="more-btn" @click="handleClickMore">
        <span>查看全部</span>
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <div class="comp-content">
      <!-- 表格头部 -->
      <div class="table-header">
        <div class="header-cell student-name-header">学生昵称</div>
        <div class="header-cell time-header">奖杯数量</div>
        <div class="header-cell course-header">上台次数</div>
        <div class="header-cell progress-header">上台时间</div>
        <div class="header-cell progress-header">正确率</div>
        <div class="header-cell progress-header">在线</div>
      </div>

      <!-- 表格内容 -->
      <div class="student-table-body">
        <div
          v-for="(item, index) in preThreeData"
          :key="index"
          class="student-table-row"
        >
          <div class="row-content">
            <div class="student-info">
              <div
                class="avatar"
                :style="{ backgroundColor: item.avatarColor }"
              >
                <img
                  v-if="index === 0"
                  src="@saas/pages/assets/images/live-data/first.png"
                  alt=""
                />
                <img
                  v-else-if="index === 1"
                  src="@saas/pages/assets/images/live-data/second.png"
                  alt=""
                />
                <img
                  v-else-if="index === 2"
                  src="@saas/pages/assets/images/live-data/third.png"
                  alt=""
                />
              </div>
              <div
                class="avatar"
                :style="{ backgroundColor: item.avatarColor }"
              >
                <img v-if="item.avatar" :src="item.avatar" alt="" />
              </div>
              <span class="student-name ellipsis">{{ item.nickname }}</span>
            </div>
            <div class="data-cell time-cell">
              {{ item.trophy_count || 0 }}
            </div>
            <div class="data-cell time-cell">
              {{ item.up_stage_count || 0 }}
            </div>
            <div class="data-cell time-cell">
              {{ formatTimeBySecond(item.up_stage_duration) }}
            </div>
            <div class="data-cell course-cell">
              {{
                item.total_num === 0
                  ? 0
                  : ((item.right_num / item.total_num) * 100).toFixed(2)
              }}%
            </div>
            <div class="data-cell progress-cell">
              {{ formatTimeBySecond(item.stay_duration) }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :title="dialogTitle"
      width="590px"
      :close-on-click-modal="false"
      custom-class="student-dialog"
      @close="handleDialogClose"
    >
      <div class="dialog-content">
        <!-- 表格头部 -->
        <div class="table-header">
          <div class="header-cell student-name-header">学生昵称</div>
          <div class="header-cell time-header">奖杯数量</div>
          <div class="header-cell course-header">上台次数</div>
          <div class="header-cell progress-header">上台时间</div>
          <div class="header-cell progress-header">正确率</div>
          <div class="header-cell progress-header">在线</div>
        </div>

        <!-- 表格内容 -->
        <div class="student-table-body">
          <template v-if="tableData.length">
            <div
              v-for="(item, index) in tableData"
              :key="index"
              class="student-table-row"
            >
              <div class="row-content">
                <div class="student-info">
                  <div
                    class="avatar"
                    :style="{ backgroundColor: item.avatarColor }"
                  >
                    <img
                      v-if="index === 0 && currentPage === 1"
                      src="@saas/pages/assets/images/live-data/first.png"
                      alt=""
                    />
                    <img
                      v-else-if="index === 1 && currentPage === 1"
                      src="@saas/pages/assets/images/live-data/second.png"
                      alt=""
                    />
                    <img
                      v-else-if="index === 2 && currentPage === 1"
                      src="@saas/pages/assets/images/live-data/third.png"
                      alt=""
                    />
                    <div v-else>
                      {{ (currentPage - 1) * pageSize + index + 1 }}
                    </div>
                  </div>
                  <div
                    class="avatar"
                    :style="{ backgroundColor: item.avatarColor }"
                  >
                    <img v-if="item.avatar" :src="item.avatar" alt="" />
                  </div>
                  <span class="student-name ellipsis">{{ item.nickname }}</span>
                </div>
                <div class="data-cell time-cell">
                  {{ item.trophy_count || 0 }}
                </div>
                <div class="data-cell time-cell">
                  {{ item.up_stage_count || 0 }}
                </div>
                <div class="data-cell time-cell">
                  {{ formatTimeBySecond(item.up_stage_duration) }}
                </div>
                <div class="data-cell course-cell">
                  {{
                    item.total_num === 0
                      ? 0
                      : ((item.right_num / item.total_num) * 100).toFixed(2)
                  }}%
                </div>
                <div class="data-cell progress-cell">
                  {{ formatTimeBySecond(item.stay_duration) }}
                </div>
              </div>
            </div>
          </template>
          <el-empty
            v-else
            description="暂无内容"
            :image="require('@/assets/img/live-list/empty.png')"
          ></el-empty>
        </div>

        <!-- 分页 -->
        <div class="pagination-container">
          <div class="pagination">
            <button
              class="pagination-btn prev"
              :disabled="currentPage === 1"
              @click="handlePrevPage"
            >
              <img
                src="@saas/pages/assets/images/live-data/arrow-right.svg"
                alt="上一页"
              />
            </button>
            <div class="pagination-info">
              <span class="current-page">{{ currentPage }}</span>
              <span class="separator">/</span>
              <span class="total-pages">{{ totalPages }}</span>
            </div>
            <button
              class="pagination-btn next"
              :disabled="currentPage === totalPages"
              @click="handleNextPage"
            >
              <img
                src="@saas/pages/assets/images/live-data/arrow-right.svg"
                alt="下一页"
              />
            </button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getStudentRankList } from "@saas/service-api/src/live-data";
import { formatTimeBySecond } from "@saas/components/src";
export default {
  props: {
    liveReport: {
      typeof: Object,
      default: () => {},
    },
  },
  data() {
    return {
      myChart: null,
      dialogType: "attend", // attend 出勤 absent缺席
      dialogVisible: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      preThreeData: [],
      formatTimeBySecond,
    };
  },
  watch: {
    liveReport: {
      handler(val) {
        if (val && val.room_id) {
          this.loadTableData();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    dialogTitle() {
      return "学员排名";
    },

    totalPages() {
      return Math.ceil(this.total / this.pageSize) || 1;
    },
  },
  methods: {
    handleClickMore() {
      this.dialogVisible = true;
      this.currentPage = 1;
      this.loadTableData();
    },
    handleDialogClose() {
      this.dialogVisible = false;
      this.tableData = [];
    },
    // 获取出勤学员
    getStudentRankList() {
      getStudentRankList({
        room_id: this.liveReport.room_id,
        page_no: this.currentPage,
        page_size: this.pageSize,
      }).then((res) => {
        if (res.code === 1) {
          this.tableData = res.data.list;
          this.total = res.data.total;
          if (this.currentPage === 1) {
            this.preThreeData = res.data.list.slice(0, 3);
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    async loadTableData() {
      try {
        this.getStudentRankList();
      } catch (error) {
        console.error("加载数据失败:", error);
        this.$message.error("加载数据失败");
      }
    },
    handlePrevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.loadTableData();
      }
    },
    handleNextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.loadTableData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.comp-container {
  width: 590px;
  height: 242px;
  background: #ffffff;
  border-radius: 24px 24px 24px 24px;
  .title {
    display: flex;
    align-items: center;
    padding: 24px 0 0 24px;
    img {
      width: 24px;
      height: 24px;
    }
    p {
      flex: 1;
      font-weight: 500;
      font-size: 16px;
      color: #0d1400;
      margin-left: 8px;
    }
    .more-btn {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 12px;
      color: #4e5969;
      margin-right: 24px;
      cursor: pointer;
      i {
        margin-left: 2px;
        font-size: 12px;
        color: #4e5969;
      }
    }
  }
  .comp-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 8px;
    padding: 0 24px;
    .echart-box {
      margin-left: 75px;
      width: 140px;
      height: 140px;
    }
    .right {
      width: 250px;
      margin-right: 50px;
      .item {
        width: 250px;
        height: 70px;
        background: #f7f8fa;
        border-radius: 12px 12px 12px 12px;
        margin-bottom: 12px;
        padding: 8px 8px 8px 16px;
        .top {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          .block {
            width: 10px;
            height: 10px;
            background: #83dcaf;
            border-radius: 3px 3px 3px 3px;
          }
          .label {
            font-weight: 400;
            font-size: 14px;
            color: #515350;
            margin-left: 5px;
            flex: 1;
          }
          .more-icon {
            width: 16px;
            height: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            img {
              transform: rotate(180deg);
              width: 6px;
              height: 9px;
            }
          }
        }
        .data {
          padding-left: 15px;
          margin-top: 6px;
          font-weight: bold;
          font-size: 24px;
          color: #000000;
          display: flex;
          height: 28px;
          line-height: 28px;
          .num {
            width: 87px;
          }
        }
      }
    }
  }
}

// 弹窗样式
::v-deep .student-dialog {
  width: 590px;
  height: 615px;
  background: #ffffff;
  border-radius: 24px 24px 24px 24px;
  display: flex;
  flex-direction: column;
  .el-dialog__header {
    padding: 24px 24px 0 24px;
    border-bottom: none;
    position: relative;
    font-size: 16px;
    .el-dialog__title {
      font-weight: 600;
      font-size: 16px;
      color: #0d1400;
      height: 22px;
      line-height: 22px;
      display: inline-block;
    }

    .el-dialog__headerbtn {
      top: 24px;
      right: 22px;
      width: 24px;
      height: 24px;
      background: transparent;
      border: none;

      .el-dialog__close {
        color: #4e5969;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }

  .el-dialog__body {
    padding: 0 24px 24px;
    flex: 1;
    overflow: hidden;
  }
}
.table-header {
  display: flex;
  margin-bottom: 16px;
  padding: 0 10px;
  .header-cell {
    font-size: 12px;
    color: #515350;
    font-weight: 400;
    &.student-name-header {
      width: 200px;
      text-align: left;
    }

    &.time-header {
      flex: 1;
      text-align: right;
    }

    &.course-header {
      flex: 1;
      text-align: right;
    }

    &.progress-header {
      flex: 1;
      text-align: right;
    }
  }
}

.student-table-body {
  flex: 1;
  overflow-y: auto;
  .student-table-row {
    margin-bottom: 8px;
    background: #f7f8fa;
    border-radius: 12px;
    &:nth-of-type(even) {
      background: #fff;
    }
    .row-content {
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;
      width: 100%;
      .student-info {
        display: flex;
        align-items: center;
        gap: 4px;
        width: 200px;
        text-align: left;
        .avatar {
          width: 20px;
          min-width: 20px;
          height: 20px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .student-name {
          font-size: 14px;
          color: #000000;
          font-weight: 400;
          line-height: 1.4;
        }
      }

      .data-cell {
        font-size: 14px;
        color: #1d2129;
        text-align: right;
        flex: 1;
        &.time-cell,
        &.course-cell,
        &.progress-cell {
          text-align: right;
        }
      }
    }
  }
}
.dialog-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  .dialog-tip {
    font-size: 14px;
    color: #0d1400;
    margin-top: 8px;
    margin-bottom: 20px;
    line-height: 1.4;
  }

  .table-header {
    display: flex;
    margin-bottom: 16px;
    padding-top: 18px;
    padding-right: 16px;
    .header-cell {
      font-size: 12px;
      color: #515350;
      font-weight: 400;
      &.student-name-header {
        width: 200px;
        text-align: left;
      }

      &.time-header {
        flex: 1;
        text-align: right;
      }

      &.course-header {
        flex: 1;
        text-align: right;
      }

      &.progress-header {
        flex: 1;
        text-align: right;
      }
    }
  }

  .student-table-body {
    // 自定义滚动条样式，确保不影响布局
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background: rgba(0, 0, 0, 0.1);
      border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.3);
      border-radius: 3px;
      &:hover {
        background: rgba(0, 0, 0, 0.5);
      }
    }
    .student-table-row {
      margin-bottom: 8px;
      background: #f7f8fa;
      border-radius: 12px;
      &:nth-of-type(even) {
        background: #fff;
      }
      .row-content {
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 40px;
        width: 100%;
        .student-info {
          display: flex;
          align-items: center;
          gap: 4px;
          width: 200px;
          text-align: left;
          .avatar {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .student-name {
            font-size: 14px;
            color: #000000;
            font-weight: 400;
            line-height: 1.4;
          }
        }

        .data-cell {
          font-size: 14px;
          color: #1d2129;
          text-align: right;
          flex: 1;
          &.time-cell {
            text-align: right;
          }

          &.course-cell {
            color: #1d2129;
            text-align: right;
          }

          &.progress-cell {
            text-align: right;
          }
        }
      }
    }
  }

  .pagination-container {
    display: flex;
    justify-content: right;
    margin-top: 20px;

    .pagination {
      display: flex;
      align-items: center;
      gap: 4px;

      .pagination-btn {
        width: 20px;
        height: 32px;
        border: none;
        border-radius: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.2s;
        padding: 8px 0;
        &.prev {
          transform: rotate(180deg);
        }
        &:hover:not(:disabled) {
          background: #fff;
        }

        &:disabled {
          background: #fff;
          cursor: not-allowed;

          img {
            opacity: 0.5;
          }
        }

        img {
          width: 12px;
          height: 12px;
        }
      }

      .pagination-info {
        display: flex;
        align-items: center;
        padding: 0 8px;
        font-size: 14px;
        color: #1d2129;
        line-height: 1.57;

        .current-page {
          width: 40px;
          height: 28px;
          font-weight: 600;
          font-size: 14px;
          color: #4e5969;
          line-height: 28px;
          background: #f2f3f5;
          border-radius: 2px 2px 2px 2px;
          text-align: center;
        }

        .separator {
          margin: 0 8px;
        }

        .total-pages {
          font-weight: 400;
        }
      }
    }
  }
}
</style>
